import React, { useEffect } from 'react'
import './About.scss';
import browser from '../../browser.png';

function About() {

    {/* useEffect(() => {
        const script = document.createElement('script');

        script.src = "http://localhost:1337/plugins/strapi-stripe/static/stripe.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        }
    }, []); */}

    return (
        <div id="about">
            <div className="row headerSpacing">
                <div className="col-md">
                    <div className="aboutText">
                        <h2>We inject a dose of simplicity within the hectic world of handicapping.</h2>
                        <p>Tired of seeing hundreds of different packages and selections? Unsure of what package to select? We are here to solve that. We come as one team, with only our most confident picks every week. The idea here is through your consistent wagering, you will see profit through our concise selection of picks from our team. Our one of a kind dashboard experience will keep you in the loop at all times, no matter your location.The world of handicapping is a marathon, not a sprint. Our team is the supplies that make your marathon extremely easy to run.</p>
                        <a className="btn successButton" href="/analytics" role="button">View Analytics</a>
                        {/* <button class="css style" type="button" id="SS_ProductCheckout" data-id="1" data-url="http://localhost:1337"> Subscribe </button> */}
                    </div>
                </div>

                <div className="col-md col-right">
                    <img className="dashboardImage" src={browser} alt="Dashboard" />
                </div>
            </div>
        </div>
    )
}

export default About
